import React from 'react';
import type { ChatMessage } from '../context/chatTypes';
import type { PaymentMessagePayload } from '../types/paymentTypes';
import { ChainsObjectsArr } from '../../../chainsStaticObject/chainsStaticData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

interface PaymentBubbleProps {
  message: ChatMessage;
}

const PaymentBubble: React.FC<PaymentBubbleProps> = ({ message }) => {
  const content = message.content as PaymentMessagePayload;
  const isSent = message.isSentByMe;

  const chainObj = ChainsObjectsArr.find((c: any) => c.chain === content.chain);
  const explorerBaseUrl = chainObj?.network?.getChainScanUrlTx?.() || '';
  const explorerUrl = explorerBaseUrl ? `${explorerBaseUrl}${content.txHash}` : '';

  const timeStr = message.sentAt.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div className="chat-payment">
      <div className="chat-payment__header">
        {isSent ? 'Sent' : 'Received'} Payment
      </div>
      <div className="chat-payment__divider" />
      <div className="chat-payment__amount">
        {content.amount} {content.tokenSymbol}
      </div>
      <div className="chat-payment__chain">
        {chainObj?.logo && (
          <img
            src={chainObj.logo}
            alt={content.chain}
            className="chat-payment__chain-icon"
          />
        )}
        <span>{chainObj?.title || content.chain}</span>
      </div>
      <div className="chat-payment__status">
        <span className="chat-payment__status-dot" />
        Confirmed
      </div>
      {explorerUrl && (
        <a
          href={explorerUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="chat-payment__explorer-link"
        >
          View on Explorer <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="xs" />
        </a>
      )}
      <div className="chat-payment__footer">
        <span className="chat-message__time">
          {timeStr}
          {isSent && <FontAwesomeIcon icon={faCheck} className="chat-message__sent-icon" />}
        </span>
      </div>
    </div>
  );
};

export default PaymentBubble;
